export const DELETE_USER = 'DELETE_USER'
export const DOWNLOAD_INVOICES = 'DOWNLOAD_INVOICES'
export const GET_ACTIVE_ROOMS = 'GET_ACTIVE_ROOMS'
export const GET_CLOSED_ROOMS = 'GET_CLOSED_ROOMS'
export const GET_SEATS = 'GET_SEATS'
export const GET_SUBSCRIPTION = 'GET_SUBSCRIPTION'
export const GET_SUBSCRIPTION_BRANDING = 'GET_SUBSCRIPTION_BRANDING'
export const GET_SUBSCRIPTION_INVOICES = 'GET_SUBSCRIPTION_INVOICES'
export const GET_SUBSCRIPTION_USERS = 'GET_SUBSCRIPTION_USERS'
export const PATCH_SUB_ADMIN = 'PATCH_SUB_ADMIN'
export const PATCH_SUB_ADMIN_BILLING = 'PATCH_SUB_ADMIN_BILLING'
export const PATCH_SUB_ADMIN_USER = 'PATCH_SUB_ADMIN_USER'
export const POST_NEW_SUBSCRIBER = 'POST_NEW_SUBSCRIBER'
export const POST_SUBSCRIPTION_TEAM = 'POST_SUBSCRIPTION_TEAM'
export const POST_ELECTRONIC_VAULT_QUOTE_REQUEST = 'POST_ELECTRONIC_VAULT_QUOTE_REQUEST'
export const PATCH_SUBSCRIPTION_TEAM = 'PATCH_SUBSCRIPTION_TEAM'
export const GET_SUBSCRIPTION_TEAMS = 'GET_SUBSCRIPTION_TEAMS'
export const GET_SUBSCRIPTION_CONSUMPTION_PACKS = 'GET_SUBSCRIPTION_CONSUMPTION_PACKS'
export const GET_SUBSCRIPTION_DATAROOM_STORAGE = 'GET_SUBSCRIPTION_DATAROOM_STORAGE'
export const RESTORE_ROOM = 'RESTORE_ROOM'
export const DELETE_SUBSCRIPTION_TEAM = 'DELETE_SUBSCRIPTION_TEAM'
export const INCREASE_DATAROOM_PLAN = 'INCREASE_DATAROOM_PLAN'
export const SHARE_SUBSCRIPTION_CONSUMPTION_PACK = 'SHARE_SUBSCRIPTION_CONSUMPTION_PACK'
export const SHARE_SUBSCRIPTION_DATAROOM_PLAN = 'SHARE_SUBSCRIPTION_DATAROOM_PLAN'
export const GET_SIGNATURES_CONSUMPTION = 'GET_SIGNATURES_CONSUMPTION'
